"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createInputJson = exports.InputJson = exports.InputJsonDefaultProps = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var styled_components_1 = __importStar(require("styled-components"));
var field_container_1 = require("../elements/field-container");
var theme_1 = require("@shapeable/theme");
var use_lang_1 = require("../../hooks/use-lang");
exports.InputJsonDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var InputStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    width: 100%;\n    font-family: ", ";\n    font-size: ", ";\n    border: 1px solid ", ";\n    ", "\n    box-sizing: border-box;\n    line-height: 1.75em;\n    padding: ", ";\n    color: ", ";\n    resize: vertical;\n    margin: 0;\n    display: block;\n    padding-bottom: 80px;\n    background: #272C35;\n    \n    &:focus {\n      outline: none;\n      border-color: ", ";\n    }\n  "], ["\n    width: 100%;\n    font-family: ", ";\n    font-size: ", ";\n    border: 1px solid ", ";\n    ", "\n    box-sizing: border-box;\n    line-height: 1.75em;\n    padding: ", ";\n    color: ", ";\n    resize: vertical;\n    margin: 0;\n    display: block;\n    padding-bottom: 80px;\n    background: #272C35;\n    \n    &:focus {\n      outline: none;\n      border-color: ", ";\n    }\n  "])), theme_1.theme.FONT('mono'), theme_1.theme.FONT_SIZE(14), theme_1.theme.COLOR('line-mid'), function (props) {
    return (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      height: ", ";\n    "], ["\n      height: ", ";\n    "])), props._height);
  }, theme_1.theme.UNIT(3), theme_1.theme.COLOR('primary'), theme_1.theme.COLOR('primary'))
});
var ErrorStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    position: absolute;\n    bottom: 1px;\n    left: 1px;\n    padding: ", ";\n    background: ", ";\n    border-top: 1px solid ", ";\n    color: ", ";\n    font-size: ", ";\n    width: calc(100% - 2px);\n    box-sizing: border-box;\n  "], ["\n    position: absolute;\n    bottom: 1px;\n    left: 1px;\n    padding: ", ";\n    background: ", ";\n    border-top: 1px solid ", ";\n    color: ", ";\n    font-size: ", ";\n    width: calc(100% - 2px);\n    box-sizing: border-box;\n  "])), theme_1.theme.UNIT(4), theme_1.theme.COLOR('#FCFCFC'), theme_1.theme.COLOR('line-subtle'), theme_1.theme.COLOR('text-mid'), theme_1.theme.FONT_SIZE(13))
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    position: relative;\n  "], ["\n    position: relative;\n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(field_container_1.FieldContainer)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Input: styled_components_1.default.textarea(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), InputStyles),
  Body: styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  Error: styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ErrorStyles)
};
var InputJson = function (props) {
  var className = props.className,
    field = props.field,
    onChange = props.onChange;
  var value = field.value,
    name = field.name;
  var _a = __read(React.useState(true), 2),
    valid = _a[0],
    setValid = _a[1];
  var _height = field.height || "400px";
  var codeAreaRef = React.useRef();
  var _b = __read(React.useState(value), 2),
    code = _b[0],
    setCode = _b[1];
  React.useEffect(function () {
    validate(value);
  }, []);
  var validate = function (value) {
    try {
      setValid(true);
      var check = JSON.stringify(JSON.parse(value), null, 2);
    } catch (e) {
      setValid(false);
    }
  };
  var handleChange = function (event) {
    var newValue = event.target && event.target.value;
    setCode(newValue);
    validate(newValue);
    onChange({
      name: name,
      value: newValue
    });
  };
  var onBlur = function (event) {
    var newValue = event.target && event.target.value;
    var prettyValue = newValue;
    try {
      prettyValue = JSON.stringify(JSON.parse(newValue), null, 2);
    } catch (e) {}
    onChange({
      name: name,
      value: prettyValue
    });
  };
  var t = (0, use_lang_1.useLang)();
  //--------------
  return React.createElement(My.Container, {
    field: field,
    className: className
  }, React.createElement(My.Body, null, React.createElement(My.Input, {
    spellCheck: false,
    ref: codeAreaRef,
    onBlur: onBlur,
    onChange: handleChange,
    _height: _height,
    onKeyDown: function (e) {
      if (e.key == 'Tab') {
        e.preventDefault();
        var _a = e.target,
          selectionStart = _a.selectionStart,
          selectionEnd = _a.selectionEnd;
        var newText = code.substring(0, selectionStart) + '  ' +
        // Edit this for type tab you want
        // Here it's 2 spaces per tab
        code.substring(selectionEnd, code.length);
        if (codeAreaRef && codeAreaRef.current) {
          // @ts-ignore
          codeAreaRef.current.focus();
          // @ts-ignore
          codeAreaRef.current.value = newText;
          // @ts-ignore
          codeAreaRef.current.setSelectionRange(selectionStart + 2, selectionStart + 2);
        }
        setCode(newText);
      }
    },
    value: code
  }), !valid && React.createElement(My.Error, null, t('Note: This value is not valid JSON, and must be corrected before it can be parsed correctly. Check that all property keys use double quotes, and there are no trailing commas'))));
};
exports.InputJson = InputJson;
exports.InputJson.defaultProps = exports.InputJsonDefaultProps;
var createInputJson = function (props) {
  return React.createElement(exports.InputJson, __assign({}, props));
};
exports.createInputJson = createInputJson;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;